import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { MatomoProvider } from "@datapunt/matomo-tracker-react";
import { initMatomoAnalyticsInstance } from "@qgiv/core-donor";
import ConnectedRoutes from "./ConnectedRoutes";
import P2PRegistrationLoadingScreen from "./common/P2PRegistrationLoadingScreen";

const AppRouter = ({ appLoading, favicon, setAppLoading }) => {
    const dispatch = useDispatch();
    const matomoAnalyticsInstance = initMatomoAnalyticsInstance();

    useEffect(() => {
        // -------------------------------------------------------------------------
        // NOTE: Removes default favicon added by webpack to allow custom favicon to
        // be added. As we build out more React Pages we might consider bringing in
        // the npm package favicon-webpack-plugin to give us more flexibility to add
        // the users custom favicon https://www.npmjs.com/package/favicons-webpack-plugin
        // -------------------------------------------------------------------------
        if (favicon?.content) {
            const defaultFavicon = document.querySelector(
                "link[href^='/frontend/apps/p2pRegistration/build/favicon.ico']",
            );
            defaultFavicon.remove();
        }

        setTimeout(() => {
            dispatch(setAppLoading(false));
        }, 250);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return appLoading ? (
        <P2PRegistrationLoadingScreen active />
    ) : (
        <MatomoProvider value={matomoAnalyticsInstance}>
            <ConnectedRoutes />
        </MatomoProvider>
    );
};

AppRouter.propTypes = {
    appLoading: PropTypes.bool.isRequired,
    favicon: PropTypes.shape({
        content: PropTypes.string,
    }).isRequired,
    setAppLoading: PropTypes.func.isRequired,
};

export default AppRouter;
